import { render } from "./CustomizeMenuItemTab.vue?vue&type=template&id=69827376&scoped=true&ts=true"
import script from "./CustomizeMenuItemTab.vue?vue&type=script&lang=ts"
export * from "./CustomizeMenuItemTab.vue?vue&type=script&lang=ts"

import "./CustomizeMenuItemTab.vue?vue&type=style&index=0&id=69827376&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69827376"]])

export default __exports__